angular.module('impactx.sapconfig').controller('TaxCodesListCtrl',
    TaxCodesListCtrl);

TaxCodesListCtrl.$inject = ['$routeParams', 'selectedListItems', 'BackService', 'BackFactory'];

function TaxCodesListCtrl($routeParams, selectedListItems, BackService, BackFactory)
{

    var ctrl = this;

    function getDetailLink() {
        return "taxcode/" + $routeParams.sapConfigId + "/" + selectedListItems.getFirstSelectedId();
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'SAPConfiguration'
        }
    ];


    this.meta = {
        rowTemplate: 'modules/sapconfig/templates/taxcodelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/sapconfiguration/taxcode/list',
        id: "taxcodelist",
        valuesInteger: [{name:"SAPCONFIG_Id", value: $routeParams.sapConfigId}],
        mainAction : {id:"new", link: "#/taxcode/" + $routeParams.sapConfigId + "/0/", icon:"mdi-plus"},
        backFunction: ctrl.backFunction,
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}